import { ProductDetailInfo } from "../ProductDetailPageTypeConfig";
import ajaxClient from "../../../../js/common/AjaxClient";

export interface PackageGalleryModalProduct {
    readonly product: ProductDetailInfo;
    readonly cheapestPrice: number;
}

export const getPackageForGalleryModal = async function(packageUrl: string): Promise<PackageGalleryModalProduct> {
    return ajaxClient.get<PackageGalleryModalProduct>(
        "/Product/jsGetPackageGalleryModal",
        { params: { packageUrl: packageUrl } },
    );
};
